<template>
    <div>
        <b-btn class="btn btn-sm btn-secondary new-employee" title="Add New Employee" v-if="showButton" v-on:click="openEmployeeModel=true">
            <i class="fa fa-plus-circle"></i>
        </b-btn>

        <!-- Modal Component -->
        <template v-if="!loading">

            <b-modal
                v-model="openEmployeeModel"
                title="New Employee"
                size="lg"
                ok-title="Create Employee"
                ok-variant="success"
                no-fade
                @hide="handleHide"
                @hidden="handleHidden"
                @ok="handleOk"
                ref="employeeModal"
                :no-close-on-backdrop="true"
                scrollable>
                <employee-form
                    ref="employeeModalForm"
                    :employee="employee"
                    :divisions="divisions"
                    :drivers="drivers"
                    :subcontractors="subcontractors"
                    :required_fields="required_fields"
                    :showCreateSubcontractor="false"
                    @employeeSaved="employeeCreated"></employee-form>
            </b-modal>

        </template>
    </div>
</template>

<script>
    export default {

        props: {
            showButton: {
                type: Boolean,
                default: true,
            },
            empDetails: {
                type: Object,
            },
        },

        data() {
            return {
                loading: true,
                employee: {
                    division_id: null,
                    subcontractor_id: null,
                    FirstName: null,
                    LastName: null,
                    email: null,
                    required_fields: [],
                },
                openEmployeeModel: false,
                required_fields: [],
            }
        },

        methods: {

            show(){
                this.openEmployeeModel = true;
            },

            handleHide(bvEvt){
                //debugging
                if(this.$root.debug)
                {
                    //console.log('Hiding Modal');
                }
            },

            handleHidden(bvEvt){
                //Reset the values
                this.employee = {};
                this.error = {};
            },

            handleOk(bvEvt) {

               //Stops the modal from closing
               bvEvt.preventDefault();

               //Show loading?

               //Do it
               this.$refs.employeeModalForm.saveEmployee();
            },

            employeeCreated(employee){
                //Close the modal
                this.$refs.employeeModal.hide();

                //Return to main list?
                this.$emit('employeeCreated', employee);
            },

            getEmployee(){
                //Send it
                this.$http
                .get('employees/edit' + (this.employee.EmployeeId ? '/' + this.employee.EmployeeId : ''))
                //.get('admin/divisions-list')
                .then(response => {
                    //Setter
                    this.divisions = response.data.divisions;
                    this.drivers = response.data.drivers;
                    this.subcontractors = response.data.subcontractors;
                    this.employee = response.data.employee;

                    this.employee.FirstName = this.empDetails.FirstName;
                    this.employee.LastName = this.empDetails.LastName;
                    this.employee.email = this.empDetails.email;

                    //Check it
                    if(response.data.required_fields)
                    {
                        //SEt it
                        this.required_fields = response.data.required_fields;
                    }

                    //console.log(this.empDetails.FirstName);

                })
                .catch(error => {

                })
                .then(() => {
                    //Reset
                    this.loading = false;
                });
            },
        },

        mounted() {
            //SEt the height
            //console.log(this.$refs.employeeModal.$refs);
            //this.$refs.employeeModal.$refs.body.style['max-height'] = window.innerHeight * 0.75 + 'px';
            this.getEmployee();
        }
    }
</script>

<style scoped>
    .new-employee {
        position: absolute;
        top: 0;
        right: -28px;
        height: 38px;
    }
</style>